import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
function Dvsim() {
  return (
    <div>
      <Navbar />
      <div className="container">
        <div className="about__body dvsim">
          <div className="title__about">
            <h1>«DORI VOSITALARINI STANDARTLASH ILMIY MARKAZI» </h1>
          </div>
          <p>
            <span>
              Oʼzbekiston Respublikasi Sogʼlikni saqlash vazirligining 2001 yil
              16 oktyabrdagi №476- sonli buyrugʼiga binoan ikki taʼsischi davlat
              tashkilotlari: Toshkent farmatsevtika instituti va Dori
              vositalarini ekspertizasi va standartizatsiyasi davlat markazi
              ishtirokida amalga oshirildi. Dori vositalarini yaratish ishlarini
              jadallashtirish va respublika tashkilotlari tomonidan yaratilgan
              dori vositalarini standartlash ishlarini xalqaro talablar
              darajasiga koʼtarish maqsadida Toshkent farmatsevtika instituti
              bazasida, xoʼjalik hisobidagi ilmiy markaz tashkil etilishi
              belgilangan edi. 2002 yil 1 yanvar oyidan boshlab «Dori
              vositalarini standartlash Ilmiy Markazi» institut hududida
              ajratilgan 2ta laboratoriya xonasida E.А. Nazarov raxbarligi
              ostida 3 nafar xodim bilan ilk bor oʼz faoliyatini boshladi.
            </span>{" "}
            <span>
              Ilmiy Markaz tomonidan tashkil etilgan 10ga yaqin GMP va GDP
              qoidalariga asosan dori vositalarini sifatini taʼminlash mavzusida
              ishlab chiqaruvchi korxona xodimlari, farmatsevtik nazorat tizimi
              mutaxasislari uchun malaka oshirish seminar-treninglari tashkil
              etildi. 250 dan ortiq ishlab chiqaruvchi  korxona xodimlari va
              ToshFarmI 60 dan ortiq professor o‘qituvchilari o‘z malakalarini
              oshirishdi.
            </span>{" "}
            <span>
              «DORI VOSITALARINI STANDARTLASH ILMIY MARKAZI» tashkiliy
              tuzilmasida qilingan.
            </span>{" "}
            <span>
              <ul>
                <li>
                  Sinov Markazi va o’z navbatida markaz tarkibida 4 ta
                  laboratoriya; Dori vositalarini nazorat qilish va standartlash
                  laboratoriyasi, Mikrobiologiya tahlil laboratoriyasi,
                  Farmakotoksikologiya laboratoriyasi, Biokimyo laboratoriyasi
                  hamda Vivariy;
                </li>
                <li> Tibbiy mahsulotlarni sertifikatlashtirish organi;</li>
                <li> Tadqiqotlar va izlanishlar bo’limi;</li>
                <li> O’quv trening bo’limi;</li>
                <li> Tibbiy diagnostika markazi faoliyat olib bormoqda.</li>
              </ul>
            </span>
            <img src="/img/dvism/1.png" alt="" />
          </p>

          <p>
            <span>
              <b>SINOV MARKAZI</b> da xalqaro O‘z DSt ISO/IEC 17025:2019
              standarti asosida akkreditatsiyadan o’tgan  quyidagi sinov
              laboratoriyalari o‘z faoliyatini olib bormoqda:
            </span>
            <span>
              <b>
                Dori vositalarini nazorat qilish va standartlash laboratoriyasi
              </b>{" "}
              – O’zbekiston Respublikasi hududiga chetdan kirib keladigan hamda
              mahalliy ishlab chiqaruvchilar tomonidan ishlab chiqariladigan
              dori vositalari va tibbiy buyumlarnii fizik-kimyoviy
              ko’rsatkichlarini sifatini nazorat qilish vazifasini bajaradi.
              Tahlillar Davlat va turli Xalqaro farmakopeya maqolalari (ГФ РУз,
              НД, ФС, ФСП, ГФ XI, ГФ XII va ГФ XIII nashrlari, BP, EP, USP, Ts,
              ГОСТ, ISO) talabi bo’yicha amalga oshiriladi. Shuningdek,
              respublika hududidagi quduq va buloqlaridan chiqayotgan
              shifobaxsh-ma’danli va ichimlik suvlarning fizik-kimyoviy
              tahlillarini O’zDSt 540:2010 изм. 1,2,3 talabiga asosan malakali
              mutaxassislar tomonidan zamonaviy sinov-o’lchov asboblari va
              uskunalardan foydalangan holda tahlillar olib boriladi.
            </span>
            <span>
              Dori vositalarini nazorat qilish va standartlash laboratoriyasida
              40 nafar xodim (laboratoriya mudiri, 1 va 2 toifali ximiklar,
              laborantlar) faoliyat yuritadi. Xodimlarning asosiy qismini yosh
              kadrlar tashkil etishiga qaramasdan, o’zlaring bilim va amaliy
              ko’nikmalari yuqoriligi bilan ajralib turadi. Muvofiqlikni
              baholashda ishtirok etadigan xar bitta xodimning faoliyati davriy
              baholab boriladi va monitoring qilinadi. Zarurat bo’lganda  Ilmiy
              Markazda xodimlarning malakasini oshirish uchun yangi tahlil
              usullar bo’yicha texnik o’qitishlar tashkil etiladi.
            </span>
            <span>
              Barcha fizik-kimyoviy ko’rsatgichlar dunyoning yеtuk ilg’or
              kompaniyalari (“Agilеnt Tеxnologiеs”, “Sartorius”, “Buchi”,
              “Matlеr Tolеdo”, Shimadzu va b.) tomonidan ishlab chiqarilgan
              zamonaviy laboratoriya asbob-uskunalarida tahlil qilinadi.
            </span>
            <span>
              Ilmiy markaz moddiy texnik bazasini xar yili yangilab, aniqliligi
              yuqori bo’lgan o’lchov va sinov vositalari bilan boyitib boradi.
              Masalan 2021-yilning o’zida Germaniyaning “Agilеnt Tеxnologiеs”
              korhonasi tomonidan ishlab chiqarilgan Yuqori Samarali Suyuqlik
              Xromatograflari (рефрактометрик, флуориметрик детекторли),
              Yaponiyaning “Shimadzu” korhonasida ishlab chiqarilgan Gaz
              Xromaografi GC-2030 AF, shu bilan birga og’ir metallarni chinligi
              va miqdoriy tahlillari uchun mo’ljallangan Atom-absorbsion
              спектрофотометр AA-7000 sotib olindi. Bu bilan oldin Dori
              vositalarini nazorat qilish va standartlash
              laboratoriyasi imkonsiz bo’lgan ko’pgina tahlillarni amalga
              oshirish imkoniyatiga ega bo’ldi.
            </span>
            <span>
              Dori vositalarini nazorat qilish va standartlash
              laboratoriyasi O‘zbekiston Respublikasi Vazirlar Mahkamasining
              2016-yil 27-oktabrda qabul qilingan 365-son qarori asosida
              tasdiqlangan Dori Vositalarining Xavfsizligi To‘g'risidagi Umumiy
              Texnik Reglamentda nazarda tutilgan barcha dori shakllarining
              xavfsizlik ko’rsatgichlarining 98%ini tahlillarini qamrab olish
              imkoniyatiga ega.
            </span>
            <img src="/img/dvism/2.png" alt="" />
            <span>
              <b> Mikrobiologiya tahlil laboratoriyasi </b> faoliyatining asosiy
              yo‘nalishi:
            </span>
            <ul>
              <li>
                dori vositalarini sertifikatlashtirish sinovlarini o‘tkazish
                (sterillik yoki mikrobiologik tozalik);
              </li>
              <li>
                dori vositalarining mikroblarga qarshi faolligini aniqlash;
              </li>
              <li>
                ozuqa muhitlarining o'sishini, selektiv va diagnostik
                xususiyatlarini aniqlash;
              </li>
              <li> ish muhitining mikrobiologik monitoringi.</li>
            </ul>
            <span>
              Tahlillarni  sifatli o’tkazish uchun  sinov sharoitlari yaxshi
              laboratoriya amaliyotiga muvofiq muntazam ravishda nazorat
              qilinadi. Laboratoriyada yuqori malakali mutaxassislar faoliyat
              olib bormoqda. Mutaxassislar har yili mamlakatimizda va xorijda
              o‘tkaziladigan treninglar, konferensiyalar, seminarlarda qatnashib
              bilim va ko’nikmalarini mustahkamlab boradilar.
            </span>
            <img src="/img/dvism/3.png" alt="" />
            <span>
              <b>Farmakotoksikologiya laboratoriyasi</b> ning asosiy vazifasi
              dori vositalari, tibbiyot buyumlari, shuningdek, tibbiy texnika
              uchun sarflanadigan materiallarni farmako-toksikologik
              ko‘rsatkichlari bo‘yicha tahlil o’tkazish, sertifikatlashtirish
              sinovlarini amalga oshirish, sifatni nazorat qilishdan iborat.
            </span>
            <span>
              Laboratoriyamiz dori vositalari va tibbiy buyumlarni quyidagi
              ko'rsatkichlar bo'yicha sinovdan o'tkazadi:
            </span>
            <ul>
              <li>Pirogenlik</li>
              <li> Anomal toksiklik;</li>
              <li>
                Dori vositalarining gistaminga o'xshash faolligini aniqlash;
              </li>
              <li>Gemolitik faol moddalar;</li>
              <li>Biologik faollik miqdorini aniqlash;</li>
              <li>
                Tibbiy asboblarning mahalliy qitiqluvchi xususiyati, teriga
                rezorbtiv ta'siri;
              </li>
              <li>
                Dori vositalarining o'tkir va surunkali toksikligi
                ko'rsatkichlarini o'rganish;
              </li>
              <li>Dori vositalarining o'ziga xos faolligi.</li>
            </ul>
            <span>
              Farmakotoksikologiya laboratoriyasida barcha tadqiqotlar yuqori
              malakali farmakologlar ishtirokida amalga oshiriladi
            </span>
            <img src="/img/dvism/4.png" alt="" />
            <span>
              <b>Biokimyo laboratoriyasi</b>da dori vositalari va tibbiy
              buyumlarda asosiy xavfsizlik ko’rsatgichlaridan biri bo’lgan
              Bakterial endotoksin ko’rsatgichi aniqlanadi. Laboratoriyada
              barcha tahlillar yuqori malakali mutahassis-bioximik tomonidan  ГФ
              РУз (2.6.14),  ГФ ХII РФ (ОФС 42-0062-07),  ГФХ III РФ
              (ОФС.1.2.4.0006.15), ГФ РБ (2.6.14.), ГФУ(2.6.14.), USP «85», ВР
              (2.6.8), EP (2.6.14), Xalqaro Farmakopeya (3 изд. Т.1 стр 176),
              ОФС 42 Уз-0001-1010-2020 va boshqa me’yoriy hujjatlar talabiga
              binoan amalga oshiriladi.
            </span>
            <span>
              <b>Vivariy</b> laboratoriya hayvonlarini saqlash va
              tadqiqot-eksperimental ishlarni amalga oshirish uchun hayvon
              yetkazib berish uchun mo'ljallangan. Vivariuyda 4 turdagi
              hayvonlar mavjud: sichqonlar, quyonlar, dengiz cho'chqalari va
              kalamushlar. Ilmiy markaz vivariysida 2000 bosh laboratoriya
              sichqoni va 1000 bosh kalamushlarni saqlash imkoniyatiga ega.
              Barcha binolar sanitariya-epidemiologiya va veterinariya
              qonunchiligi talablariga javob beradi. Hayvonlarga etkazib
              beriladigan havo ikki bosqichli tozalashdan o'tkaziladi.
              Ob'ektning biologik xavfsizligi darajasi minimal biologik xavf
              darajasiga mos keladi. Vivariuydagi ishlar GLP (Yaxshi
              laboratoriya amaliyoti) standartlariga muvofiq va texnologik
              reglamentlar asosida amalga oshiriladi. Laboratoriya hayvonlarini
              parvarish qilish bo'yicha barcha protseduralar tasdiqlangan
              standart ish tartib-qoidalariga muvofiq amalga oshiriladi.
            </span>
            <span>
              <b>Tibbiy mahsulotlarni sertifikatlashtirish</b> organi O‘z DSt
              ISO/IEC 17065:2015 standarti asosida 2020 yil dekabr oyida
              akkreditatsiyadan o’tdi va o’z faoliyatini boshladi. Bugungi kunga
              kelib sertifikatlashtirish organida 10 dan ortiq hodim faoliyat
              yuritmoqda.
            </span>
            <span>Sertifikatlashtirishning maqsad va vazifalari:</span>
            <ul>
              <li>
                odamlarning hayoti, sog‘lig‘i, yuridik va jismoniy shaxslarning
                mol-mulki hamda atrof muhit uchun xavfli bo‘lgan mahsulotlar
                realizatsiya qilinishini nazorat etib borish;
              </li>
              <li>
                mahsulotlarning jahon bozorida raqobat qila olishini ta’minlash;
              </li>
              <li>
                mamlakat korxonalari, qo‘shma korxonalar va tadbirkorlar xalqaro
                miqyosdagi iqtisodiy, ilmiy-texnikaviy hamkorlikda va xalqaro
                savdo-sotiqda ishtirok etishlari uchun sharoit yaratish.
              </li>
            </ul>
            <img src="/img/dvism/5.png" alt="" />
            <span>
              <b>Tadqiqotlar va izlanishlar bo’limi</b> dori vositalarining
              klinik sinovlariga tayyorgarlik ko'rishda, umumiy dori
              vositalarini klinik-oldi tadqiqotlarda va tibbiy asboblar
              xavfsizligini aniqlash uchun tadqiqotlar olib boradi. Ilmiy
              markazda dori vositalarini ham asl, ham generik bo'lgan preklinik
              tadqiqotlari (bioekvivalentlik, o'ziga xos faollik,
              farmakokinetika, farmakodinamika) 2002 yildan boshlab o’tkaziladi.
              Bugungi kunda ilmiy bo‘limda:
            </span>
            <ul>
              <li>allergen xossalari</li>
              <li>mahalliy og‘riqsizlantirish faolligi</li>
              <li>qon tomir o‘tkazuvchanligiga ta’siri</li>
              <li>antibakterial faollik  </li>
              <li>antifungal faollik</li>
              <li>gipotenziv faollik</li>
              <li>antihipoksik faollik</li>
              <li>kardiotonik faollik</li>
              <li>isitmani tushiruvchi ta’siri  </li>
              <li>gipolipidemik va antisklerotik ta’sir  </li>
              <li>mukolitik ta'sir</li>
              <li>gepatoprotektiv faollik  </li>
              <li>
                dorilarning yallig'lanishga qarshi faolligi kabi tadqiqotlar
                olib boriladi.{" "}
              </li>
            </ul>
            <span>
              Asbob-uskunalar, malakali kadrlar mavjudligi, sinov jarayonini
              tashkil etish-bu omillar ilmiy sinov laboratoriyasiga yuqoridagi
              ko'rsatkichlar bo'yicha tajribalar o'tkazish imkonini beradi va
              klinikoldi tadqiqotlarning muvaffaqiyati va sifatini ta'minlaydi.
            </span>
            <span>
              Bo'limda quyidagi ko'rsatkichlar bo'yicha sinovlar o'tkaziladi:
            </span>
            <ul>
              <li>Dori vositalarining bioekvivalentligini o'rganish;</li>
              <li>
                Dori vositalarining o'ziga xos faolligi, farmakokinetikasi va
                farmakodinamikasini o'rganish.
              </li>
            </ul>
            <img src="/img/dvism/6.png" alt="" />
            <span>
            <b>O’quv trening bo’limi </b> 2019 yil 31 yanvardan eʼtiboran Ilmiy Markazda Vazirlar Mahkamasi huzuridagi taʼlim sifatini nazorat qilish davlat inspeksiyasi tomonidan taqdim etilgan Litsenziya asosida mahalliy ishlab chiqaruvchi korxona xodimlari, institut bitiruvchilari hamda dori vositalarini sifatini nazorat qiluvchi boshqa tashkilot xodimlari uchun maxsus “DORI VOSITALARINI SIFATINI NAZORAT QILISH VA STANDARTLASH” xamda “MIKROBIOLOGIK TAHLIL USULLARI YORDAMIDA DORI VOSITALARINI SIFATINI NAZORAT QILISH VA STANDARTLASH”  yo‘nalishi bo‘yicha ixtisoslashgan kurs o‘z faoliyatini boshladi. Soxa bo‘yicha faoliyat yurituvchi malakali xodimlar Respublikamizda farmatsevtika sohasida amalga oshirilayotgan yuksak isloxotlar sharoitida farmatsevtika sohasining turli jabxalarida kundan kunga yangidan yangi o‘zgarishlar, dori vositalarini sifatini nazorat qilishni yangi usullari haqida tinglovchilarga keraklicha bilim va ko‘nikmalar berishlari yuqori saviyada yo‘lga qo‘yildi. Bu o’quv jarayonida tinglovchilar bilan Ilmiy Markaz hodimlari har bir mavzuni laboratoriya mashg’ulotlari asosida (master-klass ko’rinishida) olib boradilar. Yetarli amaliy, nazariy bilim va ko’nikmalarga ega bo’lgan malakali mutaxassislar o’z faoliyatlarini turli laboratoriyalarda davom ettirayotganligi Ilmiy Markazning yutuqlaridan biridir. Laboratoriyamizning yuqori malakali mutaxassislari tomonidan Toshkent farmatsevtika instituti talabalari uchun treninglar, mikrobiolog, ximik va farmakologlarning malakasini oshirish kurslari, hamda ochiq darslar va amaliy mashg‘ulotlar olib borilmoqda.

            </span>
            <img src="/img/dvism/7.png" alt="" />
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Dvsim;
